import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Apply from "../pages/apply/page";
import Song from "../pages/song/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/apply",
    element: <Apply />,
  },
  {
    path: "/song",
    element: <Song />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;